import * as yup from "yup";

export const ProductSchema = yup.object({
  categoryId: yup.string().required("Category is required"),
  name: yup
    .string()
    .required("Name is required")
    .max(150, "Name cannot exceed 150 characters"),
  storeId: yup.string().required("Store is required"),
  description: yup.string(),
  highlights: yup.string(),
  insideBox: yup.string(),
  type: yup.string().required("Type is required"),
  tags: yup.array().of(yup.string()),
  // salesPrice: yup
  //   .number()
  //   .transform((value, originalValue) =>
  //     originalValue === "" || isNaN(value) ? null : value,
  //   )
  //   .nullable()
  //   .required("Sale price is required")
  //   .min(0, "Sale price cannot be negative"),
  // cost: yup
  //   .number()
  //   .transform((value, originalValue) =>
  //     originalValue === "" || isNaN(value) ? null : value,
  //   )
  //   .nullable()
  //   .required("Purchase price is required")
  //   .min(0, "Purchase price cannot be negative"),
  salesPrice: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || isNaN(value) ? null : value,
    )
    .nullable()
    .required("Sale price is required")
    .min(0, "Sale price cannot be negative"),

  cost: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || isNaN(value) ? null : value,
    )
    .nullable()
    .required("Purchase price is required")
    .min(0, "Purchase price cannot be negative")
    .max(
      yup.ref("salesPrice"),
      "Purchase price cannot be greater than sale price",
    ),
  mediaInfos: yup.array().of(
    yup.object().shape({
      productId: yup.string(),
      mediaInfo: yup.string(),
      imagesPreview: yup.array().of(yup.string()).nullable(),
      contentType: yup.string().nullable(),
      sortOrder: yup.string(),
      status: yup.boolean(),
    }),
  ),
  relatedProducts: yup.array().of(
    yup.object().shape({
      productId: yup.string(),
      relatedProductId: yup.string(),
      sortOrder: yup.string(),
      status: yup.boolean(),
    }),
  ),
  productSocialLinks: yup.array().of(
    yup.object().shape({
      productId: yup.string(),
      socialPlatformId: yup
        .number()
        .transform((value, originalValue) =>
          originalValue === "" ? null : value,
        )
        .nullable(),
      url: yup.string(),
      status: yup.boolean(),
    }),
  ),
  productPromotions: yup.array().of(
    yup.object().shape({
      productId: yup.string(),
      promotionId: yup
        .number()
        .transform((value, originalValue) =>
          originalValue === "" ? null : value,
        )
        .nullable(),
      // .required("Promotion is required"),
      sortOrder: yup.number(),
      status: yup.boolean(),
    }),
  ),
  // pricingAndStocks: yup.array().of(
  //     yup.object().shape({
  //         productId: yup.string(),
  //         variant1: yup.string(),
  //         variant2: yup.string(),
  //         variant3: yup.string(),
  //         variant4: yup.string(),
  //         variant5: yup.string(),
  //         originalPrice: yup.string(),
  //         discountedPrice: yup.string(),
  //         skuCode: yup.string(),
  //         quantity: yup.string(),
  //         isDefault: yup.boolean()
  //     })
  // ),
  pricingAndStocks: yup.array().of(
    yup.object({
      productId: yup.string(),

      variant1: yup.string(),
      variant2: yup.string(),
      variant3: yup.string(),
      variant4: yup.string(),
      variant5: yup.string(),

      originalPrice: yup
        .number()
        .transform((v, o) => (o === "" || isNaN(v) ? null : v))
        .nullable()
        .min(0, "Price cannot be negative"),

      // discountedPrice: yup
      //     .number()
      //     .transform((v, o) => (o === "" || isNaN(v) ? null : v))
      //     .nullable()
      //     .min(0, "Special price cannot be negative"),

      // discountedPrice: yup
      //     .number()
      //     .transform((v, o) => (o === "" || isNaN(v) ? null : v))
      //     .nullable()
      //     .min(0, "Special price cannot be negative")
      //     .when("originalPrice", (originalPrice, schema) =>
      //         originalPrice != null
      //             ? schema.max(
      //                 originalPrice,
      //                 "Special price cannot be greater than original price"
      //             )
      //             : schema
      //     ),
      discountedPrice: yup
        .number()
        .transform((v, o) => (o === "" || isNaN(v) ? null : v))
        .nullable()
        .min(0, "Special price cannot be negative")
        .test(
          "not-greater-than-effective-original",
          "Special price cannot be greater than original price",
          function (discountedPrice) {
            const { originalPrice } = this.parent;

            // ✅ fallback logic
            const effectiveOriginal = originalPrice ?? discountedPrice;

            if (discountedPrice == null || effectiveOriginal == null) {
              return true;
            }

            return discountedPrice <= effectiveOriginal;
          },
        ),

      quantity: yup
        .number()
        .transform((v, o) => (o === "" || isNaN(v) ? null : v))
        .nullable()
        .min(0, "Stock cannot be negative"),

      skuCode: yup.string(),
      isDefault: yup.boolean(),
      status: yup.boolean(),
    }),
  ),

  // productVariants: yup.array().of(
  //     yup.object().shape({
  //         name: yup.string(),
  //         options: yup.array().of(
  //             yup.object().shape({
  //                 options: yup.array().of(yup.string()),
  //                 name: yup.string(),
  //                 optionImagesPreview: yup.array().of(yup.string()),
  //                 optionImages: yup.array().of(yup.string()),
  //             })
  //         ),
  //         sortOrder: yup.number(),
  //         status: yup.boolean(),
  //     })
  // ),

  productVariants: yup
    .array()
    .default([])
    .transform((value) => (Array.isArray(value) ? value : []))
    .of(
      yup.object({
        name: yup.string(),
        sortOrder: yup.number(),
        status: yup.boolean(),
        options: yup
          .array()
          .default([])
          .of(
            yup.object({
              name: yup.string(),
              options: yup.array().default([]).of(yup.string()),
              optionImages: yup.array().default([]).of(yup.string()),
              optionImagesPreview: yup.array().default([]).of(yup.string()),
            }),
          ),
      }),
    ),

  weight: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || isNaN(value) ? null : value,
    )
    .nullable()
    .min(0, "Weight cannot be negative"),
  weightUOM: yup.string(),
  length: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || isNaN(value) ? null : value,
    )
    .nullable()
    .min(0, "Length cannot be negative"),
  width: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || isNaN(value) ? null : value,
    )
    .nullable()
    .min(0, "Width cannot be negative"),
  height: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || isNaN(value) ? null : value,
    )
    .nullable()
    .min(0, "Height cannot be negative"),
  volumeUOM: yup.string(),
  warranty: yup.string(),
  warrantyType: yup.string(),
  warrantyPeriod: yup.string(),
  warrantyPolicy: yup.string(),
  specifications: yup.array().of(
    yup.object().shape({
      fieldSetId: yup.string(),
      fieldId: yup.string(),
      fieldValue: yup.string(),
      status: yup.boolean(),
    }),
  ),
  status: yup.boolean(),
  isCustomizable: yup.boolean(),
  // customizationId: yup.number()
  //     .transform((value, originalValue) =>
  //         originalValue === "" || isNaN(value) ? null : value
  //     )
  //     .nullable(),
  customizationId: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || isNaN(value) ? null : value,
    )
    .nullable()
    .when("isCustomizable", {
      is: true,
      then: (schema) =>
        schema.required(
          "Custom option is required when Customizable is enabled",
        ),
      otherwise: (schema) => schema.nullable(),
    }),
});
// .required();
